import { useState } from 'react';

import { Playground } from '../../../components/playground/Playground';
import { Description } from '../../../components/Description';
import Switch from '@rio-cloud/rio-uikit/Switch';

import ClearableInput from '@rio-cloud/rio-uikit/ClearableInput';
import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import { rioglyphIcons } from '../../../../../rioglyph/generated/RioglyphPreview';
import { iconsMetaData } from '../../../../../rioglyph/generated/rioglyphMetaData';
import type { RioglyphIconType } from '@rio-cloud/rio-uikit/components/rioglyph/RioglyphIconType';

export const RioglyphLibrary = () => (
    <div className='uikit-icons'>
        <Description headline='Icon library' anchor='iconLibrary' />
        <Playground example={<RioglyphLibraryExample />} />
    </div>
);

const RioglyphLibraryExample = () => {
    const isProd = import.meta.env.PROD || location.protocol.startsWith('https');

    const [icons, setIcons] = useState<RioglyphIconType[]>((rioglyphIcons ?? []) as RioglyphIconType[]);
    const [filterValue, setFilterValue] = useState('');
    const [filledIcons, setFilledIcons] = useState(false);
    const [disabledIcons, setDisabledIcons] = useState(false);

    const handleFilterIcons = (value: string) => {
        const filterByNameResult = (rioglyphIcons as RioglyphIconType[]).filter(icon => {
            return (
                icon.includes(value) ||
                iconsMetaData[icon as RioglyphIconType]?.toLowerCase().includes(value.toLowerCase())
            );
        });
        setIcons(filterByNameResult);
        setFilterValue(value);
    };

    const handleFilledSwitch = () => {
        setFilledIcons(prevState => !prevState);
    };

        const handleDisbaledSwitch = () => {
        setDisabledIcons(prevState => !prevState);
    };

    return (
        <>
            <div className='display-flex gap-20 margin-bottom-15'>
                <div className='max-width-300 flex-1-1'>
                    <FormLabel htmlFor='iconNameFilter'>Search</FormLabel>
                    <div className='input-group width-100pct'>
                        <span className='input-group-addon'>
                            <span className='rioglyph rioglyph-search' aria-hidden='true' />
                        </span>
                        <ClearableInput
                            id='iconNameFilter'
                            value={filterValue}
                            placeholder='Filter by icon name'
                            onChange={handleFilterIcons}
                        />
                    </div>
                </div>
                {!isProd && (
                    <>
                    <div>
                        <FormLabel>Filled icons</FormLabel>
                        <Switch
                            onChange={handleFilledSwitch}
                            checked={filledIcons}
                            minWidth={50}
                            enabledText='On'
                            disabledText='OFF'
                        />
                    </div>

                    <div>
                        <FormLabel>Disabled icons</FormLabel>
                        <Switch
                            onChange={handleDisbaledSwitch}
                            checked={disabledIcons}
                            minWidth={50}
                            enabledText='On'
                            disabledText='OFF'
                        />
                    </div></>
                )}
            </div>
            <div className='display-flex flex-wrap column-gap-10'>
                {icons?.map(icon => (
                    <div
                        key={icon}
                        className='rioglyph-preview display-flex align-items-center margin-top-10 margin-bottom-10'
                    >
                        <span
                            className={`rioglyph rioglyph-icon-off ${icon} ${filledIcons ? 'rioglyph-filled' : ''} ${disabledIcons ? 'rioglyph-disabled' : ''} text-size-h3 margin-right-10`}
                        />
                        <span className='text-light user-select-all'>{`rioglyph ${icon} ${filledIcons ? 'rioglyph-filled' : ''} ${disabledIcons ? 'rioglyph-disabled' : ''}`}</span>
                    </div>
                ))}
            </div>
        </>
    );
};
